// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1p9vA","colBig":"styles_colBig__3gJ2W","colSmall":"styles_colSmall__QtwIV"};